import {
  fetchGetActivities,
  fetchAddKeywordToActivity,
  fetchCreateActivity,
  fetchKeywordsListByActivityId,
  fetchKeywordsListByLanguage,
} from '@/api/link'

const link = {
  namespaced: true,
  state: {
    allActivitiesList: [],
    defaultActivityId: undefined,
    spinning: false,
  },
  mutations: {
    SET_ALL_ACTIVITIES_LIST: (state, allActivitiesList) => {
      state.allActivitiesList = allActivitiesList
    },
    SET_DEFAULT_ACTIVITY_ID: (state, defaultActivityId) => {
      state.defaultActivityId = defaultActivityId
    },
    SET_SPINNING: (state, spinning) => {
      state.spinning = spinning
    },
  },
  actions: {
    GetKeywordsListByActivityId(state, query) {
      return fetchKeywordsListByActivityId(query)
    },
    GetKeywordsListByLanguage(state, query) {
      return fetchKeywordsListByLanguage(query)
    },
    GetAllActivities({ commit }) {
      commit('SET_SPINNING', true)
      return fetchGetActivities()
        .then((res) => {
          commit('SET_DEFAULT_ACTIVITY_ID', res[0] ? res[0].activityId : '')
          commit('SET_ALL_ACTIVITIES_LIST', res)
          return res
        })
        .finally(() => {
          commit('SET_SPINNING', false)
        })
    },
    // keyword添加到活动
    AddKeywordToActivity({ dispatch }, wordLinkList) {
      return fetchAddKeywordToActivity(wordLinkList).then(() => {
        dispatch('GetAllActivities')
      })
    },
    // 创建活动
    CreateActivity({ dispatch }, name) {
      fetchCreateActivity({ name }).then(() => {
        dispatch('GetAllActivities')
      })
    },
  },
}

export default link
